import apiClient from '../utils/apiClient';

/**
 * Customer Service
 * Handles all API calls related to customers
 */
const customerService = {
  /**
   * Get all customers with pagination
   * @param {Number} page - Page number
   * @param {Number} limit - Number of items per page
   * @returns {Promise} - Promise resolving to customers data
   */
  getCustomers: async (page = 1, limit = 10) => {
    try {
      const response = await apiClient.get(`/customers?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customers:', error);
      throw error.response?.data || { message: 'Error fetching customers' };
    }
  },

  /**
   * Get a single customer by ID
   * @param {String} id - Customer ID
   * @returns {Promise} - Promise resolving to customer data
   */
  getCustomer: async (id) => {
    try {
      const response = await apiClient.get(`/customers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customer:', error);
      throw error.response?.data || { message: 'Error fetching customer' };
    }
  },

  /**
   * Create a new customer
   * @param {Object} customerData - Customer data
   * @returns {Promise} - Promise resolving to created customer
   */
  createCustomer: async (customerData) => {
    try {
      const response = await apiClient.post('/customers', customerData);
      return response.data;
    } catch (error) {
      console.error('Error creating customer:', error);
      throw error.response?.data || { message: 'Error creating customer' };
    }
  },

  /**
   * Update an existing customer
   * @param {String} id - Customer ID
   * @param {Object} customerData - Updated customer data
   * @returns {Promise} - Promise resolving to updated customer
   */
  updateCustomer: async (id, customerData) => {
    try {
      const response = await apiClient.put(`/customers/${id}`, customerData);
      return response.data;
    } catch (error) {
      console.error('Error updating customer:', error);
      throw error.response?.data || { message: 'Error updating customer' };
    }
  },

  /**
   * Delete a customer
   * @param {String} id - Customer ID
   * @returns {Promise} - Promise resolving to deletion result
   */
  deleteCustomer: async (id) => {
    try {
      const response = await apiClient.delete(`/customers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting customer:', error);
      throw error.response?.data || { message: 'Error deleting customer' };
    }
  }
};

export default customerService;
